import {combineReducers} from "redux"
import {itemIsLoading} from "./utils"
import {user} from "./user"

export default combineReducers({
	itemIsLoading,
	user,
})
